import type { ErrorLike } from 'types'

/**
 * The error's message, or null when there is no error.
 *
 * For an Apollo error this is already the server's GraphQL error messages, newline-joined — Apollo
 * derives `message` from the errors it carries. No unwrapping needed.
 */
export const getErrorMessage = (error: Maybe<ErrorLike>) => (error ? error.message : null)
